import { getCurrentHub } from '@sentry/core';
import { normalize } from '@sentry/utils';
import { getIPC } from '../ipc';
/**
 * Passes scope changes to the main process.
 */
export class ScopeToMain {
    constructor() {
        /** @inheritDoc */
        this.name = ScopeToMain.id;
    }
    /** @inheritDoc */
    setupOnce() {
        this._setupScopeListener();
    }
    /**
     * Sends the scope to the main process when it updates.
     */
    _setupScopeListener() {
        const scope = getCurrentHub().getScope();
        if (scope) {
            const ipc = getIPC();
            scope.addScopeListener((updatedScope) => {
                ipc.sendScope(JSON.stringify(normalize(updatedScope, 20, 2000)));
                scope.clearBreadcrumbs();
            });
        }
    }
}
/** @inheritDoc */
ScopeToMain.id = 'ScopeToMain';
